import * as LeaderboardQueries from '../../queries/leaderboard';
import { makeApolloClient, logError } from '../util';

export const SET_EVENT_LEADERBOARDS = 'SET_EVENT_LEADERBOARDS';
export const SET_LEADERBOARD = 'SET_LEADERBOARD';
export const DELETE_LEADERBOARD = 'DELETE_LEADERBOARD';

export const updateLeaderboard = leaderboard => ({
	type: SET_LEADERBOARD,
	leaderboard,
});

export const deleteLeaderboard = ({ id }) => ({
	type: DELETE_LEADERBOARD,
	leaderboardID: id,
});

export const createLeaderboard = leaderboard => ({
	type: SET_LEADERBOARD,
	leaderboard,
});

export const fetchEventLeaderboards = (leaderboards, from) => ({
	type: SET_EVENT_LEADERBOARDS,
	from,
	leaderboards,
});

export const fetchLeaderboard = (leaderboard, from) => ({
	type: SET_LEADERBOARD,
	from,
	leaderboard,
});

export const thunkFetchEventLeaderboards = (eventID, from) => async (dispatch, getState) => {
	const client = makeApolloClient(getState());
	try {
		const { eventLeaderboards } = await client.request(LeaderboardQueries.EVENT_LEADERBOARDS, {
			event_id: eventID,
		});
		dispatch(fetchEventLeaderboards(eventLeaderboards, from));
		return eventLeaderboards;
	} catch (error) {
		logError(error, 'leaderboards.actions.thunkFetchEventLeaderboards');
	}
};

export const thunkFetchLeaderboard = (leaderboardID, from) => async (dispatch, getState) => {
	const client = makeApolloClient(getState());
	try {
		const { leaderboardSettings } = await client.request(LeaderboardQueries.LEADERBOARD_SETTINGS, {
			id: leaderboardID,
		});
		dispatch(fetchLeaderboard(leaderboardSettings, from));
	} catch (error) {
		logError(error, 'leaderboards.actions.thunkFetchLeaderboard');
	}
};
